import { Component } from '@angular/core';
import { Router } from '@angular/router';

import { BasketNotificationComponent } from '@auth/components/notification-menu/components/basket-notification/basket-notification.component';
import { BasketNotificationLoaderTxml4Service } from '@auth/components/notification-menu/services/basket-notification-loader-txml4.service';

@Component({
  selector: 'tec-basket-notification-txml4',
  templateUrl: './basket-notification.component.html',
  styleUrls: ['./basket-notification.component.scss']
})
export class BasketNotificationTxml4Component extends BasketNotificationComponent {
  constructor(basketNotificationLoaderService: BasketNotificationLoaderTxml4Service, router: Router) {
    super(basketNotificationLoaderService, router, '/requestorder/basket');
  }
}
